import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-rijbewijs',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconRijbewijs {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M36 9.99V26c0 2.21-1.79 4-4 4H3.98C1.78 30 0 28.22 0 26.02V9.99C0 7.78 1.79 6 3.99 6H17v3c0 .55.45 1 1 1s1-.45 1-1V6h13.01C34.21 6 36 7.79 36 9.99M28 24c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1m2-5c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1m-1-6h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1m-12.07 5.52-1.3-3.86a1.72 1.72 0 0 0-1.64-1.19H8.04c-.74 0-1.39.47-1.64 1.18L5.08 18.5c-.05.15-.08.32-.08.48v5c0 .54.44.98.98.98h.03c.55 0 .99-.44.99-.98V23l8-.04v1.05c0 .54.44.98.98.98h.03c.54 0 .98-.44.98-.98v-5.02c0-.16-.03-.32-.08-.48Zm-9.05-3.38c.03-.09.11-.2.24-.2h5.79c.12 0 .2.09.23.19l.95 2.81H6.93zM7.75 21c-.41 0-.75-.33-.75-.74s.33-.74.75-.74a.74.74 0 1 1 0 1.48m7.02 0c-.41 0-.75-.33-.75-.74s.33-.74.75-.74a.74.74 0 1 1 0 1.48"/>
</svg>

    );
  }
}
